export const generalAttributeOptions = {

	default: {
		priority: 0,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: false,
		sort: 'alphanumeric'
	},

	'shared::ProductType::CX_CompositionType': {
		priority: 0,
	},

	'shared::ContextV3::CX_Region': {
		priority: 10,
		hidden: true,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: false,
		sort: 'alphanumeric'
	},
	'shared::ContextV3::CX_Usage': {
		priority: 11,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		requireLogin: false,
		sort: 'alphanumeric'
	},
	'shared::ProductType::CX_ProductFamily': {
		priority: 12,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::Heads::Cardinality::Count': {
		priority: 14,
		attributePriority: 'basic',
		displayStyle: 'compactSelect',
		hidden: false,
		sort: 'alphanumeric'
	},
	'root::Heads::CardinalityEBlock::Count': {
		priority: 15,
		hidden: true,
	},
	'shared::ProductType::HS_PoleCategory': {
		priority: 16,
		hidden: true,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ProductType::HS_PoleType': {
		priority: 17,
		hidden: true,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ProductType::HS_HeadMounting': {
		priority: 18,
		hidden: true,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::ProductType::HS_HousingType': {
		priority: 20,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'custom',
		customSort: [
			'Column',
			'ColumnTwist06',
			'ColumnTwist12',
			'Bollard',
			'PoleLateral',
			'PoleTop',
			'WallRecessed',
			'WallSurface',
		]
	},

	'shared::PreFilter::HS_LightEmission': {
		priority: 100,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PreFilter::HS_LightEmissionCAFilter': {
		priority: 102,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PreFilter::LU_Filter_LightEmission_CA': {
		priority: 104,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'shared::PreFilter::LU_Filter_LightEmission_Uplight': {
		priority: 106,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'LightEngine Count': {
		priority: 108,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	EBlock: {
		priority: 110,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	LightEngine: {
		priority: 114,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},


	'root::Heads::Head::EBlock::EB_ConstantLumenTechnology': {
		priority: 118,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::EB_Control': {
		priority: 120,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::EB_ControlNoWire': {
		priority: 122,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::EB_ControlWire': {
		priority: 124,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::EB_EBlockMountingType': {
		priority: 126,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: true,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::EB_ElectricalProtectionClass': {
		priority: 128,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::Heads::Head::EBlock::EB_Wattage': {
		priority: 130,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::EBlock::HS_HousingPowerConnectionPosition': {
		priority: 200,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature': {
		priority: 300,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel': {
		priority: 302,
		hidden: true,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'comboSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution': {
		priority: 304,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA': {
		priority: 306,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight': {
		priority: 308,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine::LE_LightEmissionCA': {
		priority: 310,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize': {
		priority: 312,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux': {
		priority: 314,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion': {
		priority: 316,
		hidden: false,
		attributePriority: 'base',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour': {
		priority: 318,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::LightEngine::LE_UpLight': {
		priority: 320,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::LightEngine::LE_DimmingLevel': {
		priority: 324,
		hidden: true,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'comboSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},

	'root::Heads::Head::ColourCoatingBase::HS_HousingCoating': {
		priority: 402,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::ColourCoatingBase::HS_HousingColour': {
		priority: 402,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::ColourCoating::HS_HousingColour': {
		priority: 404,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: true,
		unit: null,
	},
	'root::Poles::Pole::ColourCoatingBase::HS_HousingColour': {
		priority: 404,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric',
		/*
		sort: 'custom',
		customSort: [
			'StandardColourOfChoice',
			'Custom',
			'SeluxGraphite',
			'BlackMattTiger059',
			'SandMat',
			'ClayMat',
			'ConcreteGrayMat',
			'JetBlackRAL9005',
			'AnthraciteGreyRAL7016',
			'GraphiteGreyRAL7024',
			'IronGreyRAL7011',
			'GreyAluminiumRAL9007',
			'WhiteAluminiumRAL9006',
			'PureWhiteRAL9010',
			'TrafficWhiteRAL9016',
			'PineGreenRAL6009',
			'MossGreenRAL6005',
			'SapphireBlueRAL5003',
			'WineRedRAL3005',
			'PearledDarkGreyDB703',
			'PearledSilverGreyDB702',
			'WhiteAluminiumPerlDB701',
		]
		*/
	},
	'root::Mountings::Mounting::MountingAdapter::HS_MountingAdapterType': {
		priority: 404,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
	},
	'root::Mountings::Mounting::ColourCoatingBase::HS_HousingColour': {
		priority: 404,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'colorSelect',
		hideDisabledValues: true,
		unit: null,
	},
	'root::Heads::Head::Housing::HS_HousingConnection': {
		priority: 500,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Housing::HS_HeadType': {
		priority: 501,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'root::Heads::Head::Housing::HS_HousingHeight': {
		priority: 501,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'shared::HousingLuminaire::HS_HousingHeight': {
		priority: 502,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Housing::HS_HousingPowerConnection': {
		priority: 504,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Heads::Head::Housing::HS_HousingShape': {
		priority: 506,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},

	'root::Poles::Pole::Basic::HS_Base': {
		priority: 600,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Poles::Pole::Basic::HS_Height': {
		priority: 602,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'natural'
	},
	'root::Poles::Pole::Basic::HS_NumberPoleDoors': {
		priority: 604,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'natural'
	},

	'root::Poles::Pole::SpecialLine::HS_Construction': {
		priority: 700,
		hidden: false,
		attributePriority: 'basic',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'listSelect',
		hideDisabledValues: true,
		unit: null,
		sort: 'alphanumeric'
	},
	'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock': {
		priority: 702,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},


	'root::Heads::Head::SmartControl::HS_HousingZhaga': {
		priority: 800,
		hidden: false,
		attributePriority: 'detail',
		doNotShowWhenNoneIsOnlyOption: false,
		displayStyle: 'compactSelect',
		hideDisabledValues: false,
		unit: null,
		sort: 'alphanumeric'
	},
};
